<div class="row">
    <div class="panel panel-primary">
        <div class="panel-heading">
            <h2 class="panel-title">Congratulation</h2>
        </div>
        <div class="panel-body">
            <div class="alert alert-info">
                <p class="alert alert-success">Your account creation has been taken into account.</p>
                <p>You will receive an email soon to <b>confirm your email address</b>.</p>
                <p class="alert alert-warning"><b> Please check your email and your spam folder ! </b></p>
                <p>Once confirmed, {{config.name}} administrators will <b>manually validate</b> your account.</p>
            </div>
        </div>
    </div>
</div>
